/**
 * @fileoverview Progress Bar component
 * @author Min Hwang (mhwang@yext.com)
 */
// @ts-nocheck
import {
  yextProgressbar__bar,
  yextProgressbar__container,
} from '/ui/components/progressbar/progressbar.module.scss';

/**
 * @param {{
  *   value: number,
  * }} props
  */
export function ProgressBar({value}) {
  return (
    <div className={`${yextProgressbar__container} js-yext-progressbar__container`}>
      <progress
        className={yextProgressbar__bar}
        value={value}
        max="100">
        {value}
      </progress>
    </div>
  );
}
